import { mapState } from 'vuex';
import { generateMessage } from '@/utils/i18n';
import { catchCRUDError } from '@/business/apiTreatment/response/errorTreatment';

function formComponent({ namespace }) {
  return {
    computed: {
      ...mapState({
        isLoadingCreate(state, getters) {
          return getters[`${namespace}/isLoadingCreate`];
        },
        createError(state, getters) {
          return getters[`${namespace}/createError`];
        },
        isLoadingUpdate(state, getters) {
          return getters[`${namespace}/isLoadingUpdate`];
        },
        current(state, getters) {
          return getters[`${namespace}/current`];
        },
        newItem(state, getters) {
          return getters[`${namespace}/newItem`];
        },
        updateItem(state, getters) {
          return getters[`${namespace}/updateItem`];
        },
        updateError(state, getters) {
          return getters[`${namespace}/updateError`];
        },
      }),
    },
    data() {
      return {
        valid: true,
        item: null,
        mailChecked: false,
      };
    },
    props: {
      isEditing: {
        type: Boolean,
        default: false,
      },
      oldItem: {
        type: Object,
        required: false,
      },
      setCurrentOnUpdate: {
        type: Boolean,
      },
    },
    created() {
      // eslint-disable-next-line no-unused-expressions
      this.isEditing ? this.useCurrent() : this.useNewItem();
    },
    watch: {
      newItem(item) {
        if (item && item.id) {
          this.reset();
          this.$emit('close');
          this.$store.dispatch('modal/hideModal');
        }
      },
      createError(err) {
        if (err) {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('ADD', err)
          );
        }
      },
      updateItem(item) {
        if (item && item.id) {
          if (this.setCurrentOnUpdate)
            this.$store.dispatch(`${namespace}/setCurrent`, item);
          this.$emit('close');
          this.$store.dispatch('modal/hideModal');
        }
      },
      updateError(err) {
        if (err) {
          this.$store.dispatch(
            'snackbar/setSnackbarOpen',
            catchCRUDError('EDIT', err)
          );
        }
      },
      oldItem: {
        handler(item) {
          this.mailChecked = false;
          if (!item) {
            this.initItemFromNullItem();
          } else {
            this.initItemFromPartialItem(item);
          }
        },
        deep: true,
      },
    },
    methods: {
      update() {
        this.$store.dispatch(`${namespace}/updateItem`, this.item);
      },
      generateMessage,
      validate() {
        if (this.$refs.form.validate()) {
          if (this.isEditing) {
            this.update();
          } else {
            this.create();
          }
        }
      },
      reset() {
        this.initItemFromNullItem();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      },
      create() {
        this.$store.dispatch(`${namespace}/createItem`, this.item);
      },
      useNewItem() {
        if (this.oldItem) {
          this.initItemFromPartialItem(this.oldItem);
        } else {
          this.initItemFromNullItem();
        }
      },
      initItemFromPartialItem(oldItem) {
        this.item = oldItem;
      },
      initItemFromNullItem() {
        this.item = {};
      },
      useCurrent() {
        this.initItemFromPartialItem(this.oldItem);
      },
    },
    beforeDestroy() {
      this.$emit('close');
    },
  };
}

export default formComponent;
